import React, { useEffect } from "react"

const TAPI_COMPANY_ID = "206f5b70-99a5-4aa0-aad3-c5c7bc9fb0cf"

const TapiEmbed = () => {

    useEffect(() => {
        if (document.getElementById("tapi-embed-js")) return

        const js = document.createElement("script")
        js.id = "tapi-embed-js"
        js.src = "https://eu.tapi.app/js/embed.js"
        js.async = true
        document.head.appendChild(js)
    }, [])

    return (
        <div
            className="tapi-embedded-request"
            data-company={TAPI_COMPANY_ID}
            data-type="bot"
        ></div>
    )
}

export default TapiEmbed